import React, { useState, useEffect } from 'react'

import { useRouter } from 'next/router'
import Link from 'next/link'

import { getUserName } from '../../services/common-query'
import { doc, getDoc } from 'firebase/firestore/lite'
import { firebaseFireStore } from '../../config/firebaseFirestore'

export default function FollowersComponent(props) {
  const router = useRouter()
  const [isSellerMentor, setisSellerMentor] = useState(false)
  const [collectorName, setcollectorName] = useState('')

  useEffect(() => {
    if (props.ele && props.ele.id && props.type === 'Collectors') {
      getNameFromId()
      isUserMinterFunc()
    }
  }, [props.ele.id, props.type])

  const isUserMinterFunc = async () => {
    let dbRef = await getDoc(
      doc(firebaseFireStore, 'musicartMinters', props.ele.id),
    )

    if (dbRef.data()) {
      setisSellerMentor(true)
    }
  }

  const getNameFromId = async () => {
    let lname = await getUserName(props.ele.id)

    if (lname) {
      setcollectorName(lname)
    } else {
      setcollectorName('unknown')
    }
  }

  return (
    <Link
      prefetch={false}
      href={
        `/${props?.isForFollowing ? 'artist' : 'collector'}/` + props.ele.id
      }
    >
      <a className="block">
        <div className="flex items-center">
          <div
            className={
              isSellerMentor
                ? 'author__avatar followers-list-img author__avatar--verified avatar-icon author__avatar--verified-circle'
                : 'author__avatar followers-list-img avatar-icon'
            }
          >
            <img
              alt="profile-image"
              src={
                props.ele && props.ele.photoUrl
                  ? props.ele.photoUrl + '_250x250?alt=media'
                  : '/img/unknow.jpg'
              }
            />
          </div>
          <div className="followers_list_content">
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <h4 className="followers_list_title text_in_one_line">
                {props.type === 'Collectors' ? (
                  <>{collectorName ? '@' + collectorName : ''}</>
                ) : (
                  <>{props.ele.name ? props.ele.name : ''}</>
                )}
              </h4>
              {/* <p className="followers_list_username text_in_one_line">
                @{props.ele.name ? props.ele.name : "unknown"}
              </p> */}
            </div>
          </div>
        </div>
      </a>
    </Link>
  )
}
